import {
  Navigate,
  Route,
  Routes as RoutesDom,
  useLocation,
} from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import React from "react";
import { UserContext } from "./contexts/AuthContext";
import Content from "./pages/Content";
import { Contracts } from "./pages/Contracts";
import CourseLibrary from "./pages/CourseLibrary";
import Courses from "./pages/Courses";
import NotFound from "./pages/Errors/404";
import Evaluation from "./pages/Evaluation";
import FinancialStatement from "./pages/FinancialStatement";
import Forum from "./pages/Forum";
import Home from "./pages/Home";
import Lesson from "./pages/Lesson";
import LoginPage from "./pages/Login";
import Material from "./pages/Material";
import Profile from "./pages/Profile";
import { api } from "./services/api";
import PrivateRoutes from "./utils/auth/ProtectedRoute";
import { getProfileLocal } from "./utils/common";

// const SignContract = React.lazy(() => import("./pages/SignContract"));



const Routes = () => {


  const { profile } = React.useContext(UserContext);

  const { pathname } = useLocation();

  const actual_path = pathname.split("/")[1];


  const is_signed = !!(profile?.is_panel || getProfileLocal()?.is_panel)
  const try_login_signed = actual_path === "login" && is_signed;

  const { data } = useQuery({
    queryKey: ['studentData'],
    queryFn: () => {

      if (!is_signed) return null

      api.get('/panel/student-dashboard').then((response) => {
        return response.data.data
      }).catch((error) => {
        message.error('Erro ao carregar dados do estudante');
      })
    }

  }, {
    refetchInterval: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnSettle: false,
  })


  if (is_signed) {



    if (try_login_signed) return <Navigate to="/" />;

    // const last_path = pathname.split("/").pop();
    // const courses = data?.courses_info;
    // const course = courses?.find((course) => course.course_hash === pathname.split("/")[2]);
    // const courses_without_signed = courses?.filter((course) => course.signed_contract !== 'signed');


    // if (actual_path === "mycourses" && courses_without_signed?.includes(course) && last_path !== 'sign-contract') return <Navigate to={`mycourses/${course?.course_hash}/sign-contract`} />

  }



  return (
    <RoutesDom>


      <Route element={<PrivateRoutes />}>

        <Route index element={<Home />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/mycourses" element={<Courses />} />
        <Route path="/financial-statement" element={<FinancialStatement />} />
        <Route path="/mycourses/:course_hash" element={<Content />} />
        {/* sign-contract */}
        {/* <Route path="/mycourses/:course_hash/sign-contract" element={<SignContract />} /> */}
        <Route path="/mycourses/:course_hash/modules/:module_hash/lessons/:lesson_hash/:content_hash" element={<Lesson />} />
        <Route path="/mycourses/:course_hash/modules/:module_hash/lessons/:lesson_hash" element={<Lesson />} />
        <Route path="/mycourses/:course_hash/modules/:module_hash" element={<Lesson />} />
        <Route path="/course-library" element={<CourseLibrary />} />

        <Route path="/aluno/forum" element={<Forum />} />
        <Route path="/aluno/material" element={<Material />} />
        <Route path="/aluno/evaluation" element={<Evaluation />} />
        <Route path="/profile" element={<Profile />} />



        <Route path="*" element={<NotFound />} />



      </Route>

      <Route path="/login" element={<LoginPage />} />

      <Route path="*" element={<NotFound />} />
    </RoutesDom>
  );
};

export default Routes;
